import { useEffect, useState } from "react";
import { Panel } from "@/components/shared";
import { api, ago, label } from "@/lib/api";

const Table = ({ title, rows, testid }) => (
  <Panel testid={testid}>
    <h3 className="mb-3 font-semibold">{title}</h3>
    {rows.length === 0 ? <p className="text-sm text-muted-foreground">No data yet.</p> : rows.map((r) => (
      <div key={r.key} className="flex justify-between border-b py-1.5 text-sm last:border-0"><span>{label(r.key)}</span><span className="font-mono">{r.count}</span></div>
    ))}
  </Panel>
);

export default function AdminGrowth() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/acquisition").then((r) => setD(r.data)); }, []);
  if (!d) return <p className="text-muted-foreground">Loading…</p>;
  return (
    <div className="space-y-6" data-testid="admin-growth">
      <p className="text-sm text-muted-foreground">Last {d.days} days. Visits are counted once per browser session; signups and demo requests use the visitor's first recorded source.</p>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 [&>*]:min-w-0">
        <Table title="Visits by channel" rows={d.visits_by_channel} testid="growth-visits" />
        <Table title="AI referral visits by assistant" rows={d.ai_visits_by_engine} testid="growth-ai-visits" />
        <Table title="Signups by channel" rows={d.signups_by_channel} testid="growth-signups" />
        <Table title="AI referral signups by assistant" rows={d.ai_signups_by_engine} testid="growth-ai-signups" />
        <Table title="Demo requests by channel" rows={d.demos_by_channel} testid="growth-demos" />
      </div>
      <Panel testid="growth-recent-demos">
        <h3 className="mb-3 font-semibold">Recent demo requests</h3>
        {d.recent_demos.length === 0 ? <p className="text-sm text-muted-foreground">None yet.</p> : d.recent_demos.map((x) => (
          <div key={x.request_id} className="border-b py-2 text-sm last:border-0"><p className="font-medium">{x.name} · {x.company} · {x.email}</p>
            <p className="text-xs text-muted-foreground">{ago(x.created_at)} · {label(x.attribution?.channel || "unknown")}{x.attribution?.ai_engine ? ` (${x.attribution.ai_engine})` : ""}{x.message ? ` · ${x.message.slice(0, 140)}` : ""}</p></div>
        ))}
      </Panel>
    </div>
  );
}
